import { Flame, Zap, Target, Waves, Ban, Minus, Clock } from "lucide-react";
import { GRADE_CLASS, actionStyle, EARN } from "../lib/format";

const ICONS = { flame: Flame, zap: Zap, target: Target, waves: Waves, ban: Ban, minus: Minus, clock: Clock };

export function GradeBadge({ grade, gradeKey, score }) {
  return (
    <span
      data-testid="grade-badge"
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-mono-sg font-bold ${GRADE_CLASS[gradeKey] || GRADE_CLASS.grade_Avoid}`}
    >
      {grade}
      {score !== undefined && <span className="opacity-70">{score}</span>}
    </span>
  );
}

export function ActionBadge({ action, size = "sm" }) {
  const s = actionStyle(action);
  const Icon = ICONS[s.icon] || Minus;
  const pad = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid="action-badge"
      className={`inline-flex items-center gap-1.5 rounded-sm border font-mono-sg font-bold uppercase tracking-wide ${pad} ${s.cls}`}
    >
      <Icon size={size === "lg" ? 15 : 12} strokeWidth={2.5} />
      {s.label}
    </span>
  );
}

export function EarningsDot({ level }) {
  const e = EARN[level] || EARN.unknown;
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono-sg text-xs ${e.cls}`} title={`Earnings ${e.label}`}>
      <span className="h-2 w-2 rounded-full" style={{ background: e.dot }} />
      {e.label}
    </span>
  );
}

export function GateBar({ label, score, max, checks }) {
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const color = pct >= 80 ? "#00FF66" : pct >= 50 ? "#FFD700" : "#FF7F00";
  return (
    <div data-testid={`gate-${label}`} className="py-2.5">
      <div className="flex items-baseline justify-between">
        <span className="text-sm text-gray-300">{label}</span>
        <span className="font-mono-sg text-sm font-bold" style={{ color }}>
          {score}
          <span className="text-gray-600">/{max}</span>
        </span>
      </div>
      <div className="mt-1.5 h-1.5 w-full border border-white/10 bg-black">
        <div className="h-full transition-[width] duration-500" style={{ width: `${pct}%`, background: color }} />
      </div>
      {checks && (
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1">
          {checks.map((c, i) => (
            <span key={i} className={`text-xs ${c.pass ? "text-gray-300" : "text-gray-500"}`}>
              <span className={c.pass ? "text-[#00FF66]" : "text-[#FF7F00]"}>{c.pass ? "✓" : "✕"}</span> {c.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export function SubScore({ label, value }) {
  const color = value >= 80 ? "#00F0FF" : value >= 50 ? "#FFD700" : "#FF7F00";
  return (
    <div>
      <div className="flex items-baseline justify-between">
        <span className="text-xs uppercase tracking-wide text-gray-500">{label}</span>
        <span className="font-mono-sg text-sm font-bold" style={{ color }}>{value}</span>
      </div>
      <div className="mt-1 h-1.5 border border-white/10 bg-black">
        <div className="h-full" style={{ width: `${value}%`, background: color }} />
      </div>
    </div>
  );
}
